import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import Notifications from "../pages/notifications/page";
import Profile from "../pages/profile/page";
import Cards from "../pages/cards/page";
import Booking from "../pages/booking/page";
import BookingSuccess from "../pages/booking-success/page";
import Tracking from "../pages/tracking/page";
import Offers from "../pages/offers/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/cards",
    element: <Cards />,
  },
  {
    path: "/booking",
    element: <Booking />,
  },
  {
    path: "/booking-success",
    element: <BookingSuccess />,
  },
  {
    path: "/tracking",
    element: <Tracking />,
  },
  {
    path: "/offers",
    element: <Offers />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
